import React from 'react';
import SignIn from '../SignIn';

const SignUp = () => <SignIn initialMode="signup" />;

export default SignUp;

